import React, { useEffect, useRef, useState } from 'react';
import { Button, Modal } from 'antd';
import { MapContainer, TileLayer, useMap, Marker, Popup } from 'react-leaflet'

interface ModalLocationInterface {
  handleCancel: () => void,
  lat: number,
  lng: number,
  open?: boolean
}

const ModalLocation: React.FC<ModalLocationInterface> = ({ handleCancel, lat, lng, open }) => {
  const defaultProps = {
    center: [
      lat,
      lng
    ],
    zoom: 11
  } as any;


  return (
    <Modal title="Localización" open={open} destroyOnClose onCancel={handleCancel} footer={null}>
      <div style={{ height: '25rem', width: '100%' }}>
        <MapContainer id='map' {...defaultProps} style={{ height: "25rem", width: '100%' }} whenReady={function (s, ss) {
          setTimeout(() => {
            console.log(this?.invalidateSize?.())
          }, 20)
        }} >
          <TileLayer
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          <Marker position={defaultProps.center}>
            <Popup>
              A pretty CSS3 popup. <br /> Easily customizable.
            </Popup>
          </Marker>
        </MapContainer>
      </div>
    </Modal>
  );
};

export default ModalLocation;